import { connect } from 'react-redux';
//
import DealManagement from 'components/sidebar/deal-management/deal-management';
import { IStoreState } from 'store';
import { resetSidebar } from 'store/sidebar/actions';
import { clearDealEvaluation, getDealEvaluation } from 'store/deal-evaluation/actions';
import { canEvaluateDeal } from 'store/deal-edit/reducer';
import { editDealCancel } from 'store/deal-edit/actions';
import { cancelFormulaEdit } from 'store/formula-entry/actions';
import { clearModalContent, setModalContent } from 'store/modal/actions';
import { saveDeal } from 'store/deals/actions';

const mapStateToProps = ({ sidebar, dealEdit, dealEvaluation }: IStoreState) => ({
  activeTab: sidebar.activeTab,
  canEvaluateDeal: canEvaluateDeal(dealEdit) && dealEvaluation.isStale,
  isDealDirty: dealEdit.isDirty ?? false,
});

const mapDispatchToProps = {
  cancelFormulaEdit,
  clearDealEvaluation,
  clearModalContent,
  editDealCancel,
  getDealEvaluation,
  resetSidebar,
  saveDeal,
  setModalContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealManagement);
